var map = {
	"./en.json": 3482,
	"./en/about.json": 4417,
	"./en/authentication.json": 7255,
	"./en/book/main.json": 9524,
	"./en/comment.json": 7399,
	"./en/community.json": 4201,
	"./en/component/trailCard.json": 1206,
	"./en/contribution/trail.json": 3202,
	"./en/feedback.json": 8386,
	"./en/footer.json": 444,
	"./en/index.json": 1654,
	"./en/index/book.json": 7093,
	"./en/index/community.json": 3327,
	"./en/index/gallery.json": 7953,
	"./en/index/story.json": 4657,
	"./en/index/trails.json": 7054,
	"./en/navigation.json": 9712,
	"./en/newsletter.json": 2694,
	"./en/post/post.json": 4853,
	"./fr.json": 5627,
	"./fr/about.json": 1660,
	"./fr/authentication.json": 5864,
	"./fr/book/main.json": 2789,
	"./fr/comment.json": 1142,
	"./fr/community.json": 5563,
	"./fr/component/trailCard.json": 4633,
	"./fr/contribution/trail.json": 4221,
	"./fr/feedback.json": 6029,
	"./fr/footer.json": 5365,
	"./fr/index.json": 4071,
	"./fr/index/book.json": 3022,
	"./fr/index/community.json": 4852,
	"./fr/index/gallery.json": 9415,
	"./fr/index/story.json": 7009,
	"./fr/index/trails.json": 5918,
	"./fr/navigation.json": 3145,
	"./fr/newsletter.json": 6992,
	"./fr/post/post.json": 8252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6326;